// extracted by mini-css-extract-plugin
export default {"cls1":"odKONRqE7RRXPRlHvK4r","cls2":"TFQdj02BATFX4ZyytyOF odKONRqE7RRXPRlHvK4r"};